export default "__VITE_ASSET__xAeIFZvn__"